<template>
  <SAISelect
    :disable="disable"
    :loading="loading"
    :options="filteredOptions"
    :value="value"
    :option-label="optionLabel"
    :option-value="optionValue"
    placeholder="Select"
    emit-value
    map-options
    :fill-input="Boolean(value && !loading && options.length)"
    @filter="filterFn"
    @input="$emit('input', $event)"
  />
</template>

<script>
import { SAISelect } from 'ecx.saigon.ui.common';

export default {
  name: 'CarSearchSelect',
  props: {
    disable: Boolean,
    loading: Boolean,
    optionLabel: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    options: {
      type: Array,
      default: () => []
    },
    value: undefined
  },
  data() {
    return {
      filteredOptions: []
    };
  },
  watch: {
    options(value) {
      this.filteredOptions = value;
    }
  },
  methods: {
    filterFn(value, update) {
      update(() => {
        this.filteredOptions = this.options.filter((option) => {
          const str = option[this.optionLabel]
            ? option[this.optionLabel].toLowerCase()
            : '';
          return str.indexOf(value.toLowerCase()) > -1;
        });
      });
    }
  },
  components: {
    SAISelect
  }
};
</script>
